export const closeWebview = async (): Promise<void> => {
  const JSB = await import('@bridge/sharee');
  void JSB.view.closeActivity();
};
